import { privateApi } from "./axios"

export const getPayments = async () => {
    try {
        const response = await privateApi.get("api/payments")
        return response
    }
    catch (error) {
        throw error;
    }
}

export const getPayment = async (id: number) => {
    try {
        const response = await privateApi.get(`api/payments/${id}`)
        return response
    } catch (error) {
        throw error
    }
}

export const getPaymentMethods = async () => {
    try {
        const response = await privateApi.get("api/payments/methods")
        return response
    } catch (error) {
        throw error
    }
}

export const createPayment = async (data: any) => {
    try {
        const response = await privateApi.post(`api/payments/createandapply`, data)
        return response
    } catch (error) {
        throw error
    }
}

export const updatePayment = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/payments/${id}/invoices`, data)
        return response
    } catch (error) {
        throw error
    }
}

export const deletePayment = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/payments/${id}`)
        return response
    } catch (error) {
        throw error
    }
}

export const createRefund = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/payments/${id}/reimbursement`, data)
        return response
    } catch (error) {
        throw error
    }
}

export const getDifferencesCategories = async () => {
    try {
        const response = await privateApi.get("api/payments/differences/categories")
        return response
    } catch (error) {
        throw error
    }
}


export const getPaymentsDifferences = async () => {
    try {
        const response = await privateApi.get("api/payments/differences")
        return response
    } catch (error) {
        throw error
    }
}

export const getPaymentDifference = async (id: number) => {
    try {
        const response = await privateApi.get(`api/payments/differences/${id}`)
        return response
    } catch (error) {
        throw error
    }
}

export const updatePaymentDifference = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/payments/differences/${id}`, data)
        return response
    } catch (error) {
        throw error
    }
}

export const deletePaymentDifference = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/payments/differences/${id}`)
        return response
    }catch (error) {
        throw error
    }
}

export const getPaymentsProduction = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/payments/report?startDate=${startDate}&endDate=${endDate}`)
        return response
    } catch (error) {
        throw error
    }
}

export const getCsvDocumentForPayments = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/payments/report/csv?startDate=${startDate}&endDate=${endDate}`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getProductionByDepartementSuperviseur = async (year: string, idCustomer: number, chargeable: string) => {
    try {
        const response = await privateApi.get(`api/customerfile/report/production-dca?year=${year}&idCustomer=${idCustomer}&chargeable=${chargeable}`)
        return response
    } catch (error) {
        throw error
    }
}